//背景圖滾差
class ParallaxBG {
  constructor() {
    this.duration = 0.2;
    this.bg1      = $('.pbgAnimate1');
    this.bg2      = $('.pbgAnimate2');
  }
  actionBG(el) {
    $(window).on('scroll', (e) => {
      const $this  = $(e.currentTarget);
      let position = el.offset().top - $this.scrollTop();
      let st       = Math.round(position);
      el.css('backgroundPosition', 'center calc(50% + ' + (st * this.duration) + 'px)');
    });
  }
  parallax(){
    this.actionBG(this.bg1);
    this.actionBG(this.bg2);
  }
}




//輸出
export {ParallaxBG};


// WEBPACK FOOTER //
// ./js_new/parallax.js